module.exports = __webpack_public_path__ + "static/img/img_index_remind.9332cb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_index_remind.png
// module id = 1150
// module chunks = 0